module.exports = scrollerMenu => {
  scrollerMenu.prototype.bind = function (...methods) {
    methods.forEach(
      method => (scrollerMenu.prototype[method] = scrollerMenu.prototype[method].bind(this)),
    );
  };
};



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/bindThis.js